
import { defineComponent, reactive, onMounted, toRefs, computed } from 'vue'
import f10ApiUS from '@/api/f10ApiUS'

import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import { useRoute } from 'vue-router'
import { isLocalDev } from '@/api/config'

export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => ({})
    },
    token: {
      type: String,
      default: ''
    }
  },
  components: { Table, Nodata },

  setup(props) {
    const route = useRoute()
    const pageData = reactive({
      rawData: [] as any[],
      filterType: 'all', // 默认选中"过滤不分红"
      columns: [
        {
          title: '公告日',
          dataIndex: 'announceDate',
          key: 'announceDate',
          width: '160px',
          align: 'center'
        },
        {
          title: '拆股方案',
          dataIndex: 'splitPlan',
          key: 'splitPlan',
          width: '200px',
          align: 'center'
        },
        {
          title: '除权日',
          dataIndex: 'exDate',
          key: 'exDate',
          width: '160px',
          align: 'center'
        },
      ],
      spinning: true
    })

    // 格式化日期
    const formatDate = (timestamp: number | null) => {
      if (!timestamp) return '-'
      return window.moment(timestamp).format('YYYY-MM-DD')
    }

    // 格式化报告期
    const formatReportPeriod = (record: any) => {
      const year = new Date(record.reportDate).getFullYear()
      return `${year}${record.reportPeriodType}`
    }

    // 处理API数据（拆股）
    const processApiData = (data: any[]) => {


      return (data || []).map((item: any) => {
        const numerator = item.splitNumerator
        const denominator = item.splitDenominator
        const splitPlan = (numerator || denominator) ? `${denominator || 1}股拆${numerator || 1}股` : '-'
        return {
          ...item,
          announceDate: formatDate((item.announcementDate)),
          splitPlan,
          exDate: formatDate((item.exRightDate)),
        }
      })
    }



    onMounted(() => {

      const market = isLocalDev ? 'NASDAQ' : (route.query.market as string)
      const symbol = isLocalDev ? 'AAPL' : (route.query.code as string)

      const data = {
        data: {
          market,
          symbol,
        },
        headers: {
          token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944'
        }
      }

      f10ApiUS.getFhAndCg(data).then((res: any) => {
        if (res.data && res.data) {
          console.log('getFhAndCg split', res.data)
          const list = (res.data && res.data.splitList) ? res.data.splitList : res.data
          pageData.rawData = processApiData(list)
        }
        pageData.spinning = false
      }).catch(() => {
        pageData.spinning = false
      })
    })

    return {
      ...toRefs(pageData),


    }
  }
})
